import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/home',
      name: 'home',
      component: () => import('@/pages/index/index'),
      meta: {
        title: '首页',
        keepAlive: true,
      }
    },
    {
      path: '/classfiy',
      name: 'classfiy',
      component: () => import('@/pages/classfiy/index'),
      meta: {
        title: '分类',
        keepAlive: true,
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/pages/cart/index'),
      meta: {
        title: '购物车',
        keepAlive: true,
      }
    },
    {
      path: '/center',
      name: 'center',
      component: () => import('@/pages/center/index'),
      meta: {
        title: '个人中心',
      }
    },
    {
      path: '/password',
      name: 'password',
      component: () => import('@/pages/login/password'),
      meta: {
        title: '修改密码',
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/login/register'),
      meta: {
        title: '注册',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login/index'),
      meta: {
        title: '登陆',
      }
    }, {
      path: '/order-index',
      name: 'order-index',
      component: () => import('@/pages/order/index'),
      meta: {
        title: '我的订单',
      }
    },
    {
      path: '/search',
      name: 'search-index',
      component: () => import('@/pages/search/index'),
      meta: {
        title: '搜索页',
      }
    }, 
     {
      path: '/order-detail',
      name: 'order-detail',
      component: () => import('@/pages/order/detail'),
      meta: {
        title: '订单详情',
      }
    }, {
      path: '/detail',
      name: 'detail',
      component: () => import('@/pages/detail/index'),
      meta: {
        title: '商品详情',
      }
    }, {
      path: '/address-index',
      name: 'address-index',
      component: () => import('@/pages/address/index'),
      meta: {
        title: '地址列表',
      }
    }, {
      path: '/payment',
      name: 'payment',
      component: () => import('@/pages/payment/index'),
      meta: {
        title: '确认订单',
      }
    },
    {
      path: '/coupon-index',
      name: 'coupon-index',
      component: () => import('@/pages/coupon/index'),
      meta: {
        title: '我的优惠券',
      }
    },
    {
      path: '/coupon-all',
      name: 'coupon-all',
      component: () => import('@/pages/coupon/all'),
      meta: {
        title: '所有优惠券',
      }
    },
    {
      path: '/coupon-choose',
      name: 'coupon-choose',
      component: () => import('@/pages/coupon/choose'),
      meta: {
        title: '选择优惠券',
      }
    }, {
      path: '/integral',
      name: 'integral',
      component: () => import('@/pages/integral/index'),
      meta: {
        title: '积分兑换',
      }
    }, {
      path: '/seckill',
      name: 'seckill',
      component: () => import('@/pages/seckill/index'),
      meta: {
        title: '限时秒杀',
      }
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('@/pages/company/index'),
      meta: {
        title: '公司信息',
      }
    },{
      path: '/common',
      name: 'common',
      component: () => import('@/pages/common/index'),
      meta: {
        title: '轮播图产品',
        keepAlive: true
      }
    },{
      path: '/sign',
      name: 'sign',
      component: () => import('@/pages/sign/index'),
      meta: {
        title: '签到',
        keepAlive: true
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register' || to.path === '/home' || to.path === '/classfiy') {
    next();
  } else {
    let token = sessionStorage.getItem('token');
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js